import { deliveryLabel, deliveryClass, DeliveryControls } from "@/components/DrawDelivery";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "");

function Row({ e, adminView }) {
  const who = adminView ? [e.name, e.phone || e.email].filter(Boolean).join(" · ") : e.display;
  const st = adminView ? e.delivery?.status : e.delivery_status;
  return (
    <li className="flex items-center gap-2 text-sm py-1 border-b border-border/60 last:border-0 flex-wrap" data-testid={`draw-entry-${e.pid}`}>
      <span className="w-7 text-xs text-muted-foreground">{e.position}.</span>
      {e.prize && <span className="rounded-full bg-amber-100 text-amber-800 border border-amber-300 px-2 py-0.5 text-[11px] font-semibold">{e.prize}</span>}
      <span className="font-mono-code text-xs">{e.pid}</span>
      <span className="truncate">{who || ""}</span>
      {e.promoted_from_reserve && <span className="text-[11px] text-amber-700" data-testid={`draw-promoted-${e.pid}`}>subentrato da riserva n. {e.promoted_from_reserve} (al posto di {e.replaced_pid})</span>}
      {st && e.prize && <span className={`rounded-full border px-2 py-0.5 text-[11px] ${deliveryClass(st)}`} data-testid={`draw-delivery-badge-${e.pid}`}>{deliveryLabel(st)}</span>}
    </li>
  );
}

function RunBlock({ run, title, adminView, highlight, draw, onChanged }) {
  const manage = adminView && highlight && draw && onChanged;
  return (
    <div className={`rounded-lg border p-3 space-y-2 ${highlight ? "border-emerald-300 bg-emerald-50/50" : "border-border bg-secondary/30"}`} data-testid={`draw-run-${run.seed.slice(0, 8)}`}>
      <div className="flex items-center justify-between gap-2 flex-wrap text-xs text-muted-foreground"><b className="text-foreground text-sm">{title}</b><span>{fmt(run.created_at)}{run.by ? ` · ${run.by}` : ""}</span></div>
      <p className="text-[11px] text-muted-foreground font-mono-code break-all">nonce {run.nonce} · seed {run.seed}</p>
      <ul>{run.winners.map((w) => <div key={w.pid + w.position}><Row e={w} adminView={adminView} />{manage && <DeliveryControls draw={draw} w={w} reservesLeft={run.reserves?.length || 0} onChanged={onChanged} />}</div>)}</ul>
      {run.reserves?.length > 0 && <><p className="text-xs font-semibold mt-1">Riserve</p><ul>{run.reserves.map((w) => <Row key={w.pid + w.position} e={w} adminView={adminView} />)}</ul></>}
      {run.replaced?.length > 0 && <><p className="text-xs font-semibold mt-1 text-muted-foreground">Vincitori sostituiti</p><ul className="opacity-70">{run.replaced.map((w) => <Row key={"r" + w.pid} e={w} adminView={adminView} />)}</ul></>}
    </div>
  );
}

export function DrawResults({ draw, adminView = false, onChanged }) {
  const tests = draw.test_runs || [];
  return (
    <div className="space-y-3" data-testid="draw-results">
      {draw.final && <RunBlock run={draw.final} title="Estrazione definitiva" adminView={adminView} highlight draw={draw} onChanged={onChanged} />}
      {tests.length > 0 && (
        <details className="group" open={!draw.final}>
          <summary className="cursor-pointer text-sm font-semibold" data-testid="draw-tests-toggle">Estrazioni di prova ({tests.length})</summary>
          <div className="space-y-2 mt-2">{[...tests].reverse().map((t) => <RunBlock key={t.seed} run={t} title={t.label || "Prova"} adminView={adminView} />)}</div>
        </details>
      )}
    </div>
  );
}
